module.exports = __webpack_public_path__ + "static/carousel-generation-medemer-available-20b87033f90e0064696904c79e3bd293.jpeg";